function addBookmark(url, title) {
	if (!url) {
		url = window.location;
	}
	if (!title) {
		title = document.title;
	}
	const browser = navigator.userAgent.toLowerCase();
	if (window.sidebar) {
		// Mozilla, Firefox, Netscape
		window.sidebar.addPanel(title, url, '');
	} else if (window.external) {
		// IE or Chrome
		if (browser.indexOf('chrome') == -1) {
			// IE
			window.external.AddFavorite(url, title);
		} else {
			// Chrome
			alert(
				'Your browser cannot bookmark ' +
					url +
					' using this link. Please press CTRL+D (for Windows) OR Command+D (for Mac) to bookmark this page.'
			);
		}
	} else if (window.opera && window.print) {
		// Opera – automatically adds to sidebar if rel=sidebar in the tag
		return true;
	} else if (browser.indexOf('konqueror') != -1) {
		// Konqueror
		alert(
			'Your browser cannot bookmark ' +
				url +
				' using this link. Please press CTRL+B to bookmark this page.'
		);
	} else if (browser.indexOf('webkit') != -1) {
		// Safari
		alert(
			'Your browser cannot bookmark ' +
				url +
				' using this link. Please press CTRL+B (for Windows) OR Command+D (for Mac) to bookmark this page.'
		);
	} else {
		alert(
			'Your browser cannot bookmark ' +
				url +
				' using this link, please add this link manually.'
		);
	}
}
